import { combineActions, handleActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.setShouldLoadMore](state, { payload }) {
      return payload
    },
    [combineActions(rawActions.resetState, rawActions.resetNotificationsList)](state, { payload }) {
      return defaultState
    },
  },
  defaultState
)
